import { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CourseService from "../../APIService/CourseService";
import TaskService from "../../APIService/TaskService";
import { CourseTypeEnum } from "../../enums";
import { useCourseContext } from "../../context/courseContext";
import Loading from "../../shared/loading";
import { TaskListForPrinting } from "./taskListForPrinting";

export function PrintCourse() {
  const { setCourse, course, setTaskList, taskList } = useCourseContext();
  const params = useParams();
  const [isCourseLoading, setIsCourseLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!params.id) {
      setIsCourseLoading(false);
      setTaskList([]);
      return;
    }

    const fetchCourse = async (id: string) => {
      setIsCourseLoading(true);
      setTaskList([]);

      TaskService.getCourse(id, CourseTypeEnum.COURSE)
        .then((response) => {
          setCourse(response.data.course);
          setTaskList(response.data.tasks);
          setIsCourseLoading(false);
        })
        .catch((error) => {
          if (error.response.data.statusCode == 404) navigate("/404");
        });
    };

    fetchCourse(params.id);
  }, [params.id, setTaskList, setCourse, setIsCourseLoading]);

  const now = new Date(Date.now());
  const leadingZero = (num: number) => (num < 10 ? "0" + num : num);
  const date =
    leadingZero(now.getDate()) +
    "." +
    leadingZero(now.getMonth() + 1) +
    "." +
    now.getFullYear() +
    " " +
    leadingZero(now.getHours()) +
    ":" +
    leadingZero(now.getMinutes());

  return (
    <div className="">
      {isCourseLoading ? (
        <Loading />
      ) : (
        <Fragment>
          <h1
            className="h1ForPrint"
            dangerouslySetInnerHTML={{ __html: course.header1 }}
          />
          <h2 className="h1ForPrint">
            ({date}, minimath239.ru/course/{course.id})
          </h2>
          <TaskListForPrinting tasks={taskList} course={course} />
        </Fragment>
      )}
    </div>
  );
}
